import { Api } from '@cui/req';
import { promiseCacher } from '@cui/lcp-tools';
import { async } from '@antv/x6/lib/registry/marker/async';

export interface MyRole {
  roleKey: string;
  roleName: string;
  roleNumber: string;
}

export interface User {
  id: number;
  userAccount: string;
  userName: string;
  phoneNumber: string;
  email: string | undefined;
}

export interface Dept {
  deptId: string;
  deptName: string;
}
export interface UserInfo {
  roles: number[];
  myRoles: MyRole[];
  user: User;
  curDept: Dept;
}

// 获取用户信息
const getUserInfo = async (): Promise<UserInfo> => {
  const [, res] = await Api({
    method: 'get',
    url: '/api/gateway/system/user/info',
  });
  return res?.data;
};
export const getUserInfoCache = promiseCacher(getUserInfo);

const getUserList = async (): Promise<User[]> => {
  const [, res] = await Api({
    method: 'get',
    url: '/api/gateway/system/user/list',
  });
  return res?.data;
};
export const getUserListCache = promiseCacher(getUserList);

export const getUserByUserAccounts = async (accounts: string[]): Promise<User[]> => {
  const all = await getUserList();
  return all.filter((user) => accounts.includes(user.userAccount));
};

export const getUserInfoById = async (userId: number): Promise<UserInfo> => {
  const [, res] = await Api({
    method: 'get',
    url: `/api/gateway/system/user/${userId}`,
  });
  return res?.data;
};
